import Papa from 'papaparse'
import { useEffect, useState } from 'react'

export * from './generateRandomArray'
export * from './vibrancyUtils'
export * from './tableViewUtils'

export function useDataWithMetric(csvPath: string) {
  const [dataRow, setDataRow] = useState<any[]>()
  useEffect(() => {
    async function getData() {
      const response = await fetch(csvPath)
      const reader = response.body?.getReader()
      const result = await reader?.read()
      const decoder = new TextDecoder('utf-8')
      const csv = decoder.decode(result?.value)
      const results = Papa.parse(csv, { header: true }) // object with { data, errors, meta }
      const rows = results.data
      setDataRow(rows)
    }
    getData()
  }, [csvPath])
  return dataRow
}

export const calculateStringWidth = (stringParam: string, font: string): number => {
  const canvas = document.createElement('canvas')
  const context = canvas.getContext('2d')

  context!.font = font

  return context!.measureText(stringParam).width
}
